import { ReactNode } from 'react'

import RocketLaunchTwoToneIcon from '@mui/icons-material/RocketLaunchTwoTone'
import BuildTwoToneIcon from '@mui/icons-material/BuildTwoTone'

export interface MenuItem {
  link?: string
  icon?: ReactNode
  badge?: string
  items?: MenuItem[]
  name: string
}

export interface MenuItems {
  items: MenuItem[]
  heading?: string
}

const menuItems: MenuItems[] = [
  {
    items: [
      {
        name: 'Launchpad',
        link: '/launchpad',
        icon: RocketLaunchTwoToneIcon
      },
      {
        name: 'Start or Manage',
        link: '/start-launchpad',
        icon: BuildTwoToneIcon
      }
    ]
  }
]

export default menuItems
